import { contractDate } from "./planningDates";
export function planningOrders(orders) {
  return orders.flatMap(order => {
    if (["terminee", "terminée", "annulée", "annulee"].includes(order.status)) return [];
    const filled = new Set([...(order.confirmedCandidates || []), ...(order.contractedCandidates || [])].map(candidate => String(candidate?._id || candidate)));
    const remaining = Math.max(0, Number(order.quantity || 0) - filled.size);
    if (!remaining) return [];
    const periods = order.dateRanges?.length ? order.dateRanges : order.dates?.length ? order.dates.map(date => ({startDate:date,endDate:date})) : [{startDate:order.startDate,endDate:order.endDate || order.startDate}];
    return periods.filter(period => contractDate(period.startDate)).map((period,index) => ({
      _id:`order-${order._id}-${index}`, isOpenPosition:true, orderId:order._id,
      contractType:order.contractType || order.typeContrat || order.TypeContrat,
      IdClient:order.client?._id || order.client,
      RaisonSociale:order.client?.companyName || order.companyName || order.clientName || "Client",
      NomPrenom:`${order.qualification || "Poste"} · ${remaining} à pourvoir`,
      DateDebut:period.startDate, DateFin:period.endDate || period.startDate,
      HeureDebut:period.startHour || order.startHour, HeureFin:period.endHour || order.endHour,
      workedDays:order.workedDays || [], NumeroContrat:order.orderNumber || "Commande",
    }));
  });
}
